import React, { useEffect, useState } from "react";
import { Button, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckIcon from "@mui/icons-material/Check";
import { useSnackbar } from "../../context/snackbar.context.js";
import {
  addPoll,
  closePoll,
  getPolls,
  removePoll,
} from "../../api/poll.api.js";
import CreateEditPollModal from "../../components/modals/createEditPoll.modal.js";
import StatusChip from "../../components/chips/status.chip.js";

const AdminPollsPage = () => {
  const showSnackbar = useSnackbar();
  const [openModal, setOpenModal] = useState(false);
  const [polls, setPolls] = useState([]);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    getPolls().then((response) => {
      setPolls(response.data);
    });
  }, [refresh]);

  const handleSubmit = (formData) => {
    addPoll(formData)
      .then(() => {
        setRefresh((prev) => !prev);
        showSnackbar("Poll created!", "success");
      })
      .catch(() => showSnackbar("Failed to create Poll!", "error"));
  };

  const handleRemove = (id) => {
    removePoll(id)
      .then(() => {
        setRefresh((prev) => !prev);
        showSnackbar("Poll removed!", "success");
      })
      .catch(() => showSnackbar("Failed to remove Poll!", "error"));
  };

  const handleClose = (id) => {
    closePoll(id)
      .then(() => {
        setRefresh((prev) => !prev);
        showSnackbar("Poll closed!", "success");
      })
      .catch(() => showSnackbar("Failed to close Poll!", "error"));
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <div>
      <Typography variant="h3" gutterBottom>
        Polls Administration
      </Typography>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Question</TableCell>
              <TableCell>Is Single Choice</TableCell>
              <TableCell>Options</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {polls.map((row) => (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.question}
                </TableCell>
                <TableCell>{row.isSingleChoice && <CheckIcon />}</TableCell>
                <TableCell>{row.options.length}</TableCell>
                <TableCell>
                  <StatusChip status={row.status} />
                </TableCell>
                <TableCell>
                  {row.status == "Open" && <Button
                    variant="outlined"
                    onClick={() => handleClose(row.id)}
                    sx={{ mr: 1 }}
                    startIcon={<DeleteIcon />}
                  >
                    Close
                  </Button>}
                  <Button
                    variant="outlined"
                    onClick={() => handleRemove(row.id)}
                    startIcon={<DeleteIcon />}
                  >
                    Delete
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Button variant="contained" onClick={handleOpenModal} sx={{ mt: 1 }}>
        Create Poll
      </Button>

      <CreateEditPollModal
        aria-modal
        open={openModal}
        handleClose={handleCloseModal}
        handleSubmit={handleSubmit}
      />
    </div>
  );
};

export default AdminPollsPage;
